import LButton from './LButton.vue'
import LButtonGroup from './LButtonGroup.vue'

export default (Vue) => {
  Vue.component(LButton.name, LButton)
  Vue.component(LButtonGroup.name, LButtonGroup)
}
